import * as React from 'react';
import type { SVGProps } from 'react';
const SvgBilling = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 70 58"
    {...props}
  >
    <path
      stroke="#4B7EFF"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3}
      d="M68.333 17.333H1.667m0 13.334h11.822c1.8 0 2.701 0 3.572.155a10 10 0 0 1 2.245.68c.81.354 1.56.853 3.058 1.852l1.939 1.292c1.498.999 2.247 1.498 3.057 1.852.72.314 1.474.542 2.246.68.87.155 1.771.155 3.572.155h3.644c1.801 0 2.701 0 3.572-.155a10 10 0 0 0 2.246-.68c.81-.354 1.56-.853 3.057-1.852l1.939-1.292c1.498-.999 2.247-1.498 3.058-1.852a10 10 0 0 1 2.246-.68c.87-.155 1.77-.155 3.571-.155h11.822M1.667 13v32c0 3.734 0 5.6.726 7.027a6.67 6.67 0 0 0 2.914 2.913c1.426.727 3.293.727 7.026.727h45.334c3.733 0 5.6 0 7.026-.727a6.67 6.67 0 0 0 2.914-2.913c.726-1.426.726-3.293.726-7.027V13c0-3.734 0-5.6-.726-7.027a6.67 6.67 0 0 0-2.914-2.913c-1.426-.727-3.293-.727-7.026-.727H12.333c-3.733 0-5.6 0-7.026.727a6.67 6.67 0 0 0-2.914 2.913C1.667 7.4 1.667 9.266 1.667 13"
    />
  </svg>
);
export default SvgBilling;
